module.exports = __webpack_public_path__ + "assets/img/effective6.c4e08d4b.png";